import React, {Component} from 'react';
import Clinic from '../../api/Clinic';
import User from '../../api/User';
import SettingsHoursView from './SettingsHoursView';
import {SanitizeClassNames} from '../../common';
import './SettingsScheduling.css';
import moment from 'moment';
import Doctor from '../../api/Doctor';
import {LoadingSpinner} from '../../components/BiopedUI';
import ClinicService from '../../api/services/ClinicService';
import CalendarHoursSelectView from './CalendarHoursSelectView';

export default class SettingsScheduling extends Component{

    state = {
        timeData : [false, [9, 18], [9, 18], [9, 18], [9, 18], [9, '15:30'], false],
        selectedList : 'pedorthist',
        isBusyList: false
    }


    constructor(props){
        super(props);
        this.handleTimeChange = this.handleTimeChange.bind(this);
        this.handleDayToggle = this.handleDayToggle.bind(this);
    }

    getHourSettings(){
        let settings = this.state.settings;
        if(!this.state.settings){
            settings = new Clinic(this.props.clinicId).settings;
        }
        return settings.hours;
    }

    getSchedule(){
        if(!this.state.settings)return {};
        return this.state.settings.schedule;
    }

    getTimeData(){
        let hours = this.getSchedule().cache;
        if(!hours)return [];

        return (this.props.mode == 'exceptions')? hours.getWeekHours(this.props.date):hours.defaultWeekHours;
    }

    handleTimeChange(day, value){
        if(this.state.isBusy)return;
        console.log('handleTimeChange:', day, value)
        switch(this.props.mode){
            case 'exceptions':
                this.handleTimeChangeExceptions(day, value);
            break;
            default:
                this.handleTimeChangeDefaults(day, value);
            break;
        }


        //this.state.timeData[day] = value;
    }

    handleTimeChangeExceptions(day, value){
        let schedule = this.getSchedule();
        let hours = schedule.cache;
        let date = moment(this.props.date).day(day);
        let defDayHours = hours.defaultWeekHours[day];

        if(hours.isSameHours(value, defDayHours)){
            //hours.deleteDateHoursException(date);
            this.handleDeleteException(date);
        }else{
            //hours.setDateHoursException(date, value);
            this.handleSetException(date, value);
        }
    }

    handleTimeChangeDefaults(day, value){
        let schedule = this.getSchedule();
        let hours = schedule.cache;
        let weekHours = hours.defaultWeekHours;
        weekHours[day] = value;
        this.setState({isBusy: true, isBusyList: schedule.userId});
        schedule.setDefaultWeekHours(weekHours).then(()=>{
            this.setState({isBusy: false, isBusyList: false});
        });
    }

    handleDeleteException = (date) =>{
        let schedule = this.getSchedule();
        this.setState({isBusy: true, isBusyList: schedule.userId});
        schedule.deleteException(date).then(() => {
            this.setState({isBusy: false, isBusyList: false});
        });
    }

    handleSetException = (date, hours) =>{
        let schedule = this.getSchedule();
        this.setState({isBusy: true, isBusyList: schedule.userId});
        schedule.setException(date, hours).then(() => {
            this.setState({isBusy: false, isBusyList: false});
        })
    }

    clearExceptions(){
        let doctors = ClinicService.GetDoctors(null, true);
        for(let i=0; i < doctors.length; i++){
            let doctor = new Doctor(doctors[i]);
            doctor.settings.schedule.getExceptions().then((exceptions) => {
                for(let i=0; i < exceptions.length; i++){
                    doctor.settings.schedule.deleteException(exceptions[i].date);
                }
            })
        }
    }

    /*componentDidMount(){
        this.clearExceptions()
    }*/

    /*handleTimeChange(day, value){
        let hours = this.getHourSettings();
        let date = moment(this.props.date).day(day);
        let defDayHours = hours.defaultWeekHours[day];

        if(hours.isSameHours(value, defDayHours)){
            hours.deleteDateHoursException(date);
        }else{
            hours.setDateHoursException(date, value);
        }

        //this.state.timeData[day] = value;
    }*/

    handleDayToggle(day, state){
        this.handleTimeChange(day, state ? [9,18]: false);
        //this.forceUpdate();
    }

    handleSelectListHeader(list){
        let state = {selectedList:list};
        if(list === 'clinic'){
            state.settings = null;
            if(this.props.changeMode){
                this.props.changeMode('hourPrefs');
            }
        }else{
            if(this.props.changeMode){
                this.props.changeMode('exceptions');
            }
        }
        this.setState(state);
    }

    handleDoctorSelect = (doctor) =>{
        this.setState({isBusyList:doctor.userId, isBusy:true});
        let schedule = doctor.settings.schedule;
        schedule.load().then(()=>{
            this.setState({isBusyList:false,isBusy:false, settings:doctor.settings});
        })
    }

    handleCalendarViewTimePrefChange = (day, time)=>{
        console.log('Calendar PRefs Change: ', time);
        let startTime = moment(time[0], 'H:mm');
        let endTime = moment(time[1], 'H:mm');
        let dr = ClinicService.GetDrById();
        dr.settings.setData('CalendarViewTimeStart', startTime.hour() );
        dr.settings.setData('CalendarViewTimeEnd', endTime.hours() );
        setTimeout(() => {
            console.log("Update Forced in Calnedar PReffs")
            this.forceUpdate();
        }, 10);
        //this.forceUpdate();
        //this.setState({viewStartTime: startTime.hour(), viewEndTime: endTime.hour()});
    }

    render(){
        let viewMode = this.state.selectedList;
        let dr = ClinicService.GetDrById();

        return(
            <div className={SanitizeClassNames(this, 'settings-scheduling table align-top ' + this.state.selectedList)}>
                <div>
                    <div>
                        {/*Pedorthist List */}
                        <div className={'list-header ' + ((this.state.selectedList == 'pedorthist')? 'selected':'') } onClick={()=>this.handleSelectListHeader('pedorthist')}>Pedorthist Hours</div>
                        <PedorthistList clinicId={this.props.clinicId} onDrSelect={this.handleDoctorSelect} isBusy={this.state.isBusyList} />
                        <div className={'list-header ' + ((this.state.selectedList == 'clinic')? 'selected':'') } onClick={()=>this.handleSelectListHeader('clinic')}>View Hours</div>
                    </div>
                    <div>
                        {/* time Grid */}
                        {viewMode === 'clinic'? <CalendarHoursSelectView startTime={1} endTime={23} activeStartTime={dr.settings.getData('CalendarViewTimeStart') || 8} activeEndTime={dr.settings.getData('CalendarViewTimeEnd') || 18} onTimeChange={this.handleCalendarViewTimePrefChange} /> : <SettingsHoursView headerFormat={ (this.props.mode == 'exceptions')? 'ddd MMM D':'dddd'  } clinicId={this.props.clinicId} date={this.props.date} startTime={7} endTime={22} activeStartTime={9} activeEndTime={18} timeData={this.getTimeData()} onTimeChange={this.handleTimeChange} onDayStateToggle={this.handleDayToggle} />}
                    </div>
                </div>
            </div>
        )
    }
}

class PedorthistList extends Component{
    state = {isBusy:false};

    updateDoctors(clinicId){
        if(!this.props.clinicId && !clinicId) return;
        let service = new Clinic(clinicId || this.props.clinicId);
        this.doctors = service.doctors.getAll().map((d) => {
            let doctor = new Doctor(d);
            let isSelected = (this.state.selected)? (this.state.selected.userId === doctor.userId): false;
            return <div key={doctor.userId} onClick={()=> this.handleDoctorSelect(doctor)} className={isSelected? 'selected':''} >
                        {doctor.fullName} {(this.props.isBusy === doctor.userId)? <LoadingSpinner />:null}
                    </div>
        })
    }

    handleDoctorSelect(d){
        console.log("Doctor Selected: ", d);
        if(this.props.isBusy !== false)return;
        //this.setState({isBusy:d.userId})
        this.setState({selected:d});
        if(this.props.onDrSelect){
            this.props.onDrSelect(d);
        }





    }

    render(){
        this.updateDoctors();
        return(
            <div className='doctor-list'>
                {this.doctors}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/views/Settings/SettingsScheduling.js